import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpHeaders, HttpHeaderResponse, HttpRequest } from '@angular/common/http';
//import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
// import 'rxjs/add/operator/map';
import { map ,delay} from 'rxjs/operators';

import { AppGlobals } from '../shared/app.global';
import  dataurl from '../../assets/config.json';


  

@Injectable()
export class MentorService {

    callurl: string = '';
  
    clcd:string;
    aycd:string;
    usid:string;
    
        constructor(private http: HttpClient,private _global: AppGlobals) {
    
           this.clcd=localStorage.getItem('clcd');
           this.aycd=localStorage.getItem('aycd');
           this.usid=localStorage.getItem('usid');
         
           this.callurl=_global.baseAPIUrl;
         }

         
         getdatetoday()
         {
          let d: Date = new Date();
          var mnth;
          var day='';
          //let todayDate = {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()};
          if(d.getMonth()>=10)
          {
            mnth=d.getMonth()+1;
          }
          else{
           // mnth='0'+d.getMonth()+1;
           mnth=d.getMonth()+1;
           mnth='0'+mnth;
          }
       
          if(d.getDate()>=10)
          {
            day=d.getDate().toString();
          }
          else{
            day='0'+d.getDate();
          }
          let todayDate =  d.getFullYear()+'-'+ mnth+'-' +day;
            
       return todayDate;
       
         }
         classmaster(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_masclass/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_masclass;
                    
                }));
          }
         
          getstualloted(clid,stfid,oprtype): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
           // console.log('url',this.callurl + 'getmentstualloted/'+this.clcd+'/'+this.aycd+'/'+stfid+'/'+clid+'/'+oprtype)
            
            return this.http.get(this.callurl + 'getmentstualloted/'+this.clcd+'/'+this.aycd+'/'+stfid+'/'+clid+'/'+oprtype)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.stualloted;
                    
                }));
          }

          getmentschedules(oprtype,schdt,schto): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
           console.log('url',this.callurl + 'getmentschedules/'+this.clcd+'/'+this.aycd+'/'+this.usid+'/'+schdt+'/'+schto+'/'+oprtype)
            
            return this.http.get(this.callurl + 'getmentschedules/'+this.clcd+'/'+this.aycd+'/'+this.usid+'/'+schdt+'/'+schto+'/'+oprtype)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.montschedules;
                    
                }));
          }

          
          savementschedules(oprtype,schdt,stuid,clid): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
           // console.log('url',this.callurl + 'getmentstualloted/'+this.clcd+'/'+this.aycd+'/'+stfid+'/'+clid+'/'+oprtype)
           
           var postdata={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,stfid:this.usid,schdt:schdt,schid:0,stuid:stuid,clid:clid}
            console.log('postdata',postdata)
            return this.http.post(this.callurl + 'savementschedule',postdata)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }


          savementreviews(oprtype,id,remarks): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
           // console.log('url',this.callurl + 'getmentstualloted/'+this.clcd+'/'+this.aycd+'/'+stfid+'/'+clid+'/'+oprtype)
           
           var postdata={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,schid:id,remarks:remarks}
            console.log('postdata',postdata)
            return this.http.post(this.callurl + 'savereviews',postdata)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }
          allotstudent(stuid,stfid,oprtype,id): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            //console.log('url',this.callurl + 'getmentstualloted/'+this.clcd+'/'+this.aycd+'/'+stfid+'/'+clid+'/'+oprtype)
            
            return this.http.get(this.callurl + 'mentstuallot/'+this.clcd+'/'+this.aycd+'/'+stfid+'/'+stuid+'/'+this.usid+'/'+id+'/'+oprtype)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
          }
          mascastecat(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'mascastecat/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.mascastecat;
                    
                }));
          }
          masacademicyear(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'masacademicyear/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.masacademicyear;
                    
                }));
          }
          massubcomb(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_exmsubcomb/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_exmsubcomb;
                    
                }));
          }

          mashouse(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_mashouse/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_mashouse;
                    
                }));
          }

          maspayopt(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_accpayoptions/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_accpayoptions;
                    
                }));
          }

          masfeequota(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_accfeequota/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_accfeequota;
                    
                }));
          }

          masmot(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_masmot/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_masmot;
                    
                }));
          }
          massection(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_massection/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_massection;
                    
                }));
          }

          masclass(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_masclass/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_masclass;
                    
                }));
          }
        


          sel_sp_massubgp() {
            let clcd=this.clcd;
            let aycd=this.aycd;
            return this.http.get(this._global.baseAPIUrl + 'sel_sp_massubgp/'+clcd+'/'+aycd)
                .pipe(map((data: any) => {
                    return data.sp_massubgp;
                }));
        }
        save_sp_massubgp(secdata: any): Observable<any> {

            secdata.clcd=this.clcd;
            secdata.aycd=this.aycd;
            return this.http.post(this._global.baseAPIUrl + 'save_sp_massubgp', secdata)
                .pipe(map((data: any) => {
                    console.log('retres', 'response');
                    return data
                }));
        }

        sel_sp_massubcat() {

          let clcd=this.clcd;
            let aycd=this.aycd;
          return this.http.get(this._global.baseAPIUrl + 'sel_sp_massubcat/'+clcd+'/'+aycd)
              .pipe(map((data: any) => {
                  return data.sp_massubcat;
              }));
      }
      save_sp_massubcat(secdata: any): Observable<any> {
        secdata.clcd=this.clcd;
        secdata.aycd=this.aycd;
          return this.http.post(this._global.baseAPIUrl + 'save_sp_massubcat', secdata)
              .pipe(map((data: any) => {
                  console.log('retres', 'response');
                  return data
              }));
      }
  

      sel_sp_massubjects() {
        let clcd=localStorage.getItem('clcd');
        let aycd=localStorage.getItem('aycd');
        return this.http.get(this._global.baseAPIUrl + 'sel_sp_massubjects/'+clcd+'/'+aycd)
            .pipe(map((data: any) => {
                return data.sp_massubjects;
            }));
    }
    save_sp_massubjects(secdata: any): Observable<any> {
        secdata.clcd=this.clcd;
        secdata.aycd=this.aycd;
        return this.http.post(this._global.baseAPIUrl + 'save_sp_massubjects', secdata)
            .pipe(map((data: any) => {
                console.log('retres', 'response');
                return data
            }));
    }


    sel_sp_exmsubcomb() {
      let clcd=localStorage.getItem('clcd');
      let aycd=localStorage.getItem('aycd');
      return this.http.get(this._global.baseAPIUrl + 'sel_sp_exmsubcomb/'+clcd+'/'+aycd)
          .pipe(map((data: any) => {
              return data.sp_exmsubcomb;
          }));
  }
  save_sp_exmsubcomb(secdata: any): Observable<any> {
    secdata.clcd=this.clcd;
    secdata.aycd=this.aycd;
      return this.http.post(this._global.baseAPIUrl + 'save_sp_exmsubcomb', secdata)
          .pipe(map((data: any) => {
              console.log('retres', 'response');
              return data
          }));
  }

  sel_sp_masasshead() {

    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    return this.http.get(this._global.baseAPIUrl + 'sel_sp_masasshead/'+clcd+'/'+aycd)
        .pipe(map((data: any) => {
            return data.sp_masasshead;
        }))
}
masclasssubject(clssubdata: any): Observable<any> {
    return this.http.post(this._global.baseAPIUrl + 'by_sp_masclasssubject', clssubdata)
        .pipe(map((data: any) => {
            console.log('retres', 'response');
            return data
        }));
}
save_sp_masasshead(secdata: any): Observable<any> {
    return this.http.post(this._global.baseAPIUrl + 'save_sp_masasshead', secdata)
        .pipe(map((data: any) => {
            console.log('retres', 'response');
            return data
        }));
}
}